import { axiosInstance } from '@/modules/shared/lib/axios'
import { ScannerSettingsModel } from './types'

type Props = {
  companyId: string
}

export function getScannerSettings({ companyId }: Props) {
  return axiosInstance.get<ScannerSettingsModel>(`/api/${companyId}/configuration/scanner`)
}
